import Logo from "../../assets/image/header/mindtherapiyLogo.svg";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom"; // useNavigate'i import edin

const SignInHeader = () => {
  const { t } = useTranslation();
  const navigate = useNavigate(); // useNavigate hook'u oluşturun


  const handleLogoClick = () => {
    navigate("/"); // Ana sayfaya yönlendirme
  };

  return (
    <div className="flex flex-wrap items-center justify-between gap-y-4 mb-6 notranslate" translate="no">
      <div className="flex-shrink-0 cursor-pointer" onClick={handleLogoClick}>
        <img src={Logo} alt="MindTherHappyHub Logo" className="w-[170px]" />
      </div>
      <h1 className="text-[20px] md:text-[32px] font-poppins text-text font-[700] mx-auto">
        <span>{t("welcome")}</span>
      </h1>
      <Box>
        {/* <Button
          onClick={handleLanguageMenuOpen}
          sx={{
            color: "#625480",
            border: "1px solid #625480",
            borderRadius: "50px",
            padding: "6px 16px",
            fontFamily: "Orelega One",
            fontSize: "14px",
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            "&:hover": {
              backgroundColor: "#E5D3DD",
            },
          }}
        >
          🌐 {language}
        </Button>
        <Menu
          anchorEl={languageAnchorEl}
          open={Boolean(languageAnchorEl)}
          onClose={handleLanguageMenuClose}
        >
          <MenuItem onClick={() => handleLanguageChange("en")}>EN</MenuItem>
          <MenuItem onClick={() => handleLanguageChange("tr")}>TR</MenuItem>
        </Menu> */}
      </Box>
    </div>
  );
};

export default SignInHeader;